import { Component } from '@angular/core';
import { CommonModule, AsyncPipe } from '@angular/common';
import { MarkdownModule } from 'ngx-markdown';
import { AccordionModule } from 'primeng/accordion';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';
import { ButtonModule } from 'primeng/button';
import { RouterModule } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { LogService } from '@bioconnect-ui/log-service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { StatisticsComponent } from '../statistics/statistics.component';
import { TileNavComponent } from '../tile-nav/tile-nav.component';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ButtonModule,
    CardModule,
    MarkdownModule,
    AccordionModule,
    AsyncPipe,
    DividerModule,
    StatisticsComponent,
    TileNavComponent,
  ],
  selector: 'bioconnect-ui-portal-home',
  templateUrl: './portal-home.component.html',
  styleUrls: ['./portal-home.component.css']
})
export class PortalHomeComponent {
  videoUrl: SafeResourceUrl | undefined;

  constructor(
    public auth: AuthService,
    private logService: LogService,
    private sanitizer: DomSanitizer
  ) {
    this.showVideo();
  }

  openDocs() {
    this.logService.logEvent(`quick start doc link click`);
  }

  showVideo() {
    const vimeoId = '1232091994?h=0c891fa15f&autoplay=0&muted=1';
    const url = `https://player.vimeo.com/video/${vimeoId}`;
    this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
